import { FormControl, InputLabel, TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { Controller } from "react-hook-form";

const ControlledFormDesktopDatePicker = ({
  datePickerProps,
  control,
  defaultValue,
  id,
  label,
  name,
  readonly,
  trigger,
  ...props
}) => {
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field: { onChange, ref, value } }) => (
        <FormControl>
          <InputLabel>{label}</InputLabel>
          <DesktopDatePicker
            format={"dd-MMM-yyyy"}
            onChange={onChange}
            readOnly={!!readonly}
            renderInput={(params) => (
              <TextField variant="standard" {...params} />
            )}
            sx={{ minWidth: "16em" }}
            value={value}
            {...datePickerProps}
          />
        </FormControl>
      )}
      {...props}
    />
  );
};
export { ControlledFormDesktopDatePicker };
